"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckTeamPlugin = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const user_ui_1 = require("@sierralabs/user-ui");
const workflow_core_1 = require("@sierralabs/workflow-core");
const CheckTeamConfigurator = props => {
    var _a;
    const { condition, onChange } = props;
    const { groupList, isLoading, error, findGroups } = (0, user_ui_1.useFindGroups)();
    (0, react_1.useEffect)(() => {
        findGroups({ limit: 100 });
    }, [findGroups]);
    return (react_1.default.createElement(core_1.Box, { mt: 2 },
        react_1.default.createElement(core_1.TextField, { fullWidth: true, variant: 'outlined', error: !!error, select: !!groupList, disabled: !groupList, label: isLoading ? 'Loading...' : 'Team Permission', helperText: (error === null || error === void 0 ? void 0 : error.message) ||
                'Pick a team that has the appropriate permission to perform this transition.', value: ((_a = condition.params) === null || _a === void 0 ? void 0 : _a.groupIds) || [], SelectProps: {
                multiple: true,
                renderValue: selected => {
                    if (!Array.isArray(selected)) {
                        return;
                    }
                    return selected
                        .map((value) => {
                        const group = groupList === null || groupList === void 0 ? void 0 : groupList.data.find(g => g.id === value);
                        return (group === null || group === void 0 ? void 0 : group.name) || '?';
                    })
                        .join(', ');
                },
                onChange: event => {
                    if (condition.params) {
                        condition.params.groupIds = event.target.value;
                        onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
                    }
                }
            } }, groupList === null || groupList === void 0 ? void 0 : groupList.data.map(group => {
            var _a, _b;
            return (react_1.default.createElement(core_1.MenuItem, { key: group.id, value: group.id },
                react_1.default.createElement(core_1.Checkbox, { color: 'primary', checked: !!((_b = (_a = condition.params) === null || _a === void 0 ? void 0 : _a.groupIds) === null || _b === void 0 ? void 0 : _b.includes(group.id)) }),
                react_1.default.createElement(core_1.ListItemText, { primary: group.name })));
        }))));
};
const CheckTeamDisplay = () => {
    return react_1.default.createElement(react_1.default.Fragment, null, "Check Team Permission");
};
function findGroups(ids) {
    const request = core_ui_1.api.get('groups', { ids });
    return { request, result: (0, core_ui_1.apiResolve)(request) };
}
exports.CheckTeamPlugin = {
    type: 'check-team',
    label: 'Check Team Permission',
    configurator: CheckTeamConfigurator,
    display: CheckTeamDisplay,
    validate: () => true,
    validateImport: (condition) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const groupIds = ((_a = condition === null || condition === void 0 ? void 0 : condition.params) === null || _a === void 0 ? void 0 : _a.groupIds) || [];
        const { data, error } = yield findGroups(groupIds).result;
        if (error) {
            return {
                severity: 'warning',
                message: `${error.error || 'Error'}: ${error.message || 'An error occurred.'}`
            };
        }
        const success = groupIds.every(id => {
            return ((data === null || data === void 0 ? void 0 : data.data) || []).some(group => group.id === id);
        });
        if (!success) {
            return { severity: 'error', message: 'Some Teams were not found.' };
        }
    }),
    guard: (state, params) => {
        var _a;
        console.log('guards: check-team', state, params);
        return (0, workflow_core_1.CheckTeamGuard)(((_a = state.context) === null || _a === void 0 ? void 0 : _a.user.groups) || [], params);
    }
};
//# sourceMappingURL=CheckTeamPlugin.js.map